// @flow

import * as React from 'react';
import {useIntl} from 'react-intl';
import {useLocation} from 'docs/data';
import {useStripeClui} from '../../helpers/react/provider';
import CluiButtonLink from '../ButtonLink';
import FeedbackIcon from './FeedbackIcon';
import './FeedbackAction.scss';
import messages from './messages';

export const FEEDBACK_PAGE_URL = '/docs/dev-tools-csat?devTool=shell';

export const FeedbackAction = (): React.Node => {
  const {formatMessage} = useIntl();
  const {pushLocation} = useLocation();
  const {close} = useStripeClui();

  return (
    <>
      <CluiButtonLink
        label={<FeedbackIcon />}
        tip={formatMessage(messages.feedbackToolTip)}
        onClick={() => {
          close();
          pushLocation(FEEDBACK_PAGE_URL);
        }}
      />
    </>
  );
};

export default FeedbackAction;
